import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCh_l6i0HmWR2v_vclcV2DrUrGocX0uwkY",
  authDomain: "mockup-portal.firebaseapp.com",
  projectId: "mockup-portal",
  storageBucket: "mockup-portal.firebasestorage.app",
  messagingSenderId: "246041743963",
  appId: "1:246041743963:web:1d8b5e626284b3968ba57e"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app);
export const db = getFirestore(app);

// Restrict to your Workspace domain
provider.setCustomParameters({
  hd: 'profitoptics.com' 
});
